var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ZIndex } from '@atomic/obj.constants';
export var HeaderStyled = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media all and (min-height: 20em) {\n    position: sticky;\n    top: 0;\n    z-index: ", ";\n  }\n"], ["\n  @media all and (min-height: 20em) {\n    position: sticky;\n    top: 0;\n    z-index: ", ";\n  }\n"])), ZIndex.top);
var templateObject_1;
